module.exports = __webpack_public_path__ + "img/arrow-lt.20b7d370.svg";